var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"pure-component-frame"},[_c(_setup.SmartDisplayC,_vm._b({attrs:{"compId":_setup.getModuleId(_setup.activeModule),"mode":_setup.isMobile ? 'mob-pure' : 'pure'}},'SmartDisplayC',_setup.getModuleProps(_setup.activeModule),false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }